<template>
    <section class="modal-container contact" v-if="showContact">
        <div>
            <div class="header-rainbow"></div>
            <button v-on:click="close()" class="close">
                <Icon icon="close"></Icon>
            </button>
            <PromptHeader :step="3" :title="$t('contactform.form.title')"></PromptHeader>
            <main>
                <div class="background-bar">
                    <div class="form__container">
                        <div class="form__grid">
                            <div class="contactform__title">
                                <span v-if="!sending && !successful">
                                    {{ $t('contactform.title') }}
                                </span>
                            </div>
                            <div class="contact-person">
                                <div class="details">
                                    <div class="img_border">
                                        <ImageLoader :name="contactData.name" :src="contactData.portrait"></ImageLoader>
                                    </div>
                                    <div class="arrow"></div>
                                    <div class="data">
                                        <strong>{{ contactData.name }}</strong>
                                        <span>{{ contactData.position }}</span>
                                        <a :href="'tel:' + contactData.phone">{{ contactData.phone }}</a>
                                        <a :href="'mailto:' + contactData.email">
                                            <font-awesome-icon :icon="['far', 'envelope']" :width="20" :height="20"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div class="form">
                                <div v-if="sending" class="loader">
                                    <LoaderImg></LoaderImg>
                                </div>
                                <div v-else-if="successful" class="message">
                                    <div v-html="$t('contact.successful')"></div>
                                    <button v-on:click="close()" class="btn-dark">{{ $t('contact.back') }}</button>
                                </div>
                                <div v-else>
                                    <div v-if="error != ''" class="error">
                                        {{ error }}
                                    </div>
                                    <FormInputField name="company" :label="$t('contact.company')" required
                                                    :pattern="textPattern"
                                                    :submitted="submitted" :limit="50"></FormInputField>
                                    <FormInputField name="name" :label="$t('contact.name')" required
                                                    :pattern="textPattern"
                                                    :submitted="submitted" :limit="50"></FormInputField>
                                    <FormInputField name="email" :label="$t('contact.email')" required=""
                                                    :pattern="emailPattern"
                                                    :submitted="submitted" :limit="50"></FormInputField>
                                    <FormInputField name="phone" :label="$t('contact.phone')" pattern="^[0-9 \+]{6,}$"
                                                    :submitted="submitted" :limit="20"></FormInputField>
                                    <TextareaField name="message" :label="$t('contact.message')" required
                                                   :pattern="textPattern"
                                                   :submitted="submitted"></TextareaField>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="button__wrapper">
                    <button v-on:click="close()" class="cancel">{{ $t('buttons.back') }}</button>
                    <button v-if="!successful && !sending" v-on:click="submit" class="btn-dark">{{ $t( 'buttons.send')
                        }}
                    </button>
                </div>
            </main>
        </div>
    </section>
</template>

<script>
  import Prompt from './Prompt'
  import ImageLoader from './ImageLoader'
  import TextareaField from './TextareaField'
  import formValidationMixin from '../mixins/formValidationMixin'
  import formDataMixin from '../mixins/formDataMixin'
  import FormInputField from './FormInputField'
  import LoaderImg from './LoaderImg'

  export default {
    name: 'ContactForm',
    components: { LoaderImg, FormInputField, TextareaField, ImageLoader },
    extends: Prompt,
    mixins: [formValidationMixin, formDataMixin],
    data: function () {
      return {
        textPattern: '^[^<>\'\"\`\$]{3,}$',
        emailPattern: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,5}))$',
        validateFields: [
          'company',
          'name',
          'email',
          'phone',
          'message'
        ],
        submitted: false,
        sending: false,
        successful: false,
        error: ''
      }
    },
    computed: {
      showContact: function () {
        // return true; // @todo remove after styling
        if (this.$store.state.showContact) {
          this.show()
          return true
        } else {
          // this.hide(); // hiding mode-cover
          return false
        }
      },
      /**
       * get contact profile data
       */
      contactData: function () {
        return this.$store.state.contact
      },
    },
    methods: {
      /**
       * close contact form modal
       */
      close () {
        // reset form status
        this.submitted = false
        this.successful = false
        // reset error
        this.error = ''

        // hide contact form
        this.$store.commit('setContactStatus', false)
      },

      submit (e) {
        e.preventDefault()
        // send form data if all fields are valid
        if (this.isValid()) {
          // show loader
          this.sending = true

          this.$store.dispatch('sendContact', this.getRequestData()).then((response) => {

            // hide loader
            this.sending = false

            // set form as submitted if server returns success
            if (response.data.success) {
              this.successful = true
            } else {
              // set error message (message is server-side translated)
              this.error = response.data.error
            }

          })
        }
      }
    }
  }
</script>
